import { FormsModule } from '@angular/forms';
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { VesselTank } from '../vessel-tank.model';
import { TankSummaryComponent } from '../tank-transfer/tank-summary/tank-summary.component';
import { TrashButtonComponent } from '../trash-button/trash-button.component';
import {
  ReorderAction,
  ReorderButtonsComponent,
} from '../reorder-buttons/reorder-buttons.component';

@Component({
  selector: 're-tank-debunker',
  templateUrl: './tank-debunker.component.html',
  styleUrl: './tank-debunker.component.css',
  imports: [
    TankSummaryComponent,
    FormsModule,
    ReorderButtonsComponent,
    TrashButtonComponent,
  ],
})
export class TankDebunkerComponent implements OnInit {
  @Input({ required: true }) from!: VesselTank;
  @Input({ required: true }) action: any;
  @Output() delete = new EventEmitter<any>();
  @Output() reorder = new EventEmitter<{ id: number; action: ReorderAction }>();
  progress2 = 0;
  fromProgress = 0;
  debunkerAmount = 0;

  onDelete() {
    this.delete.emit(this.action);
  }

  get maxDebunkerAmount(): number {
    return this.from.content?.quantity || 0;
  }

  calculateProgress() {
    const capacity = this.from.capacity ?? 0;
    const quantity = this.from.content?.quantity ?? 0;

    this.fromProgress =
      capacity > 0 ? ((quantity - this.debunkerAmount) / capacity) * 100 : 0;

    this.progress2 = capacity > 0 ? (this.debunkerAmount / capacity) * 100 : 0;
  }

  ngOnInit() {
    this.calculateProgress();
  }

  onModelChange() {
    this.action.tankOperations = [
      {
        tank: {
          ...this.from,
        },
        fuel: {
          fuelGrade: this.from.content?.fuelGrade,
          quantity: -this.debunkerAmount,
        },
      },
    ];
  }

  onReorder(action: any) {
    this.reorder.emit({
      id: this.action.id,
      action: action,
    });
  }

  onEmptyTank() {
    this.debunkerAmount = this.from.content?.quantity || 0;
    this.calculateProgress();
    this.onModelChange();
  }

  onInputChange(): void {
    this.calculateProgress();
  }
}
